module.exports = __webpack_public_path__ + "static/media/wordpress.20be2fb8.png";